import { instanceOEF } from '../../api/api'

const PRODUCTS_DICT = {
  '1': 'monthlyCuradoria',
  '2': 'semesterlyCuradoria',
  '3': 'yearlyCuradoria',
  '4': 'monthlyIneditos',
  '5': 'semesterlyIneditos',
  '6': 'yearlyIneditos',
  '22': 'clubeBooksterCompleto',
}

export function postLeadEventToHermesClient( eventIdentifier, email ) {
  const hermesRequestBody = {
    'origin': 'ada',
    'eventData': {
      'eventType': 'lead-create-event',
      'type': 'conversion',
      email,
      'details': {
        'identifier': eventIdentifier,
      }
    }
  }

  instanceOEF.post( '/hermes/proxy', hermesRequestBody ).catch( error => {
    // eslint-disable-next-line no-console
    console.warn( 'Cannot post lead to OEF hermes proxy', error )
  } )
}

export const getProductNameFromPlanId = ( planId ) => {
  if ( planId === null || typeof planId === 'undefined' ) {
    return 'unregisteredProduct'
  }
  const productName = PRODUCTS_DICT[ planId.toString() ]
  return productName ? productName : 'unregisteredProduct'
}

export const rdReactivationEvent = ( { planId, email } ) => {
  const eventIdentifier = `checkout_ada_${getProductNameFromPlanId( planId )}_reativacao`
  postLeadEventToHermesClient( eventIdentifier, email )
}

export const rdRenovationEvent = ( { planId, email } ) => {
  const eventIdentifier = `checkout_ada_${getProductNameFromPlanId( planId )}_renovacao`
  postLeadEventToHermesClient( eventIdentifier, email )
}

export const rdUpgradeEvent = ( { planId, email } ) => {
  const eventIdentifier = `checkout_ada_${getProductNameFromPlanId( planId )}_upgrade`
  postLeadEventToHermesClient( eventIdentifier, email )
}

export const rdSecondSubscriptionEvent = ( { planId, email } ) => {
  const eventIdentifier = `checkout_ada_${getProductNameFromPlanId( planId )}_segunda_assinatura`
  postLeadEventToHermesClient( eventIdentifier, email )
}
